import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NguCarousel, NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { CONSTANTS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import * as _ from 'underscore';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import * as jQuery from 'jquery';
export interface DeviceInterface {
	impressions: number;
	clicks?: number;
	clickThroughRate?: number;
	device?: number;
	cost?: number;
	viewThroughs?: number;
	viewThroughRate?: number;
	household_visits?: number;
	website_attributions?: number;
	youtube_verified_imprs?: number;
	youtubeVerifiedImprsRate: number;
}

@Component({
	selector: 'app-device-donut-carousel-v1',
	styleUrls: ['./device-donut-carousel-v1.component.css'],
	templateUrl: './device-donut-carousel-v1.component.html'
})
export class DeviceCarouselV1Component implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() colors: string;
	@Input() groupby: string;
	@Input() fields: any;
	@Input() colorsconfig: any;
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() piechartconfiguration: any;
	@ViewChild('carousel') carousel: NguCarousel<any>;
	@Input() sectionclass: string;
	@Input() uniqueoverwriteid: string;
	public showLoad = true;
	public carouselOne: NguCarouselConfig;
	public deviceChartObjArray: any[] = [];
	public colorPalette: ColorPalette;
	public selectedFieldName = '';
	public downloadConfiguration: DownloadConfig;
	public hasData = true;
	public reloadSubscription;
	public widgetDataSubscription;
	public downloadCSVColumns;
	protected carouselToken: string;
	public isR1: boolean = false;
	public isR103: boolean = false;

	public isR101: boolean = false;
	public isR104: boolean = false;
	public isR8: boolean = false;
	public isGam: boolean;
	public gamMapAccess: boolean = false;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			point: {
				visible: false
			},
			touch: true,
			velocity: 0.2
		};
	}

	ngOnInit(): void {
		this.isR1 = this.analyticsDataModel.config.version === 'R1' ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103'
				? true
				: false;
		this.isR101 = this.analyticsDataModel.config.partner.directoryName === 'default-r101' ? true : false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.isR8 = this.analyticsDataModel.config.version.toUpperCase() == 'R8';
		this.isGam = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
		this.gamMapAccess = this.analyticsDataModel.setupData.userPermissions['hasGamMapAccess'];
		this.fields = JSON.parse(decodeURI(this.fields));
		this.fields = _.filter(this.fields, (item) => {
			item = item == 'youtube_verified_imprs' ? { permission: { flags: ['hasYoutubeViews'] } } : item;
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.piechartconfiguration = this.piechartconfiguration ? JSON.parse(decodeURI(this.piechartconfiguration)) : [];
		if (this.isR101 && this.isGam && !this.gamMapAccess) {
			jQuery('div#' + this.uniqueoverwriteid).removeClass('analytics-portlet-50p');
			jQuery('div#' + this.uniqueoverwriteid).addClass('analytics-portlet-100p');
			this.piechartconfiguration.width = 900;
			this.piechartconfiguration.margin = [0, 0, 50, 0];
		}
	}

	ngAfterViewInit(): void {
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	initDataFn(key: NguCarouselStore): void {
		this.setSubTitle(key.currentSlide);
		this.carouselToken = key.token;
	}

	onmoveFn(eventObj: any): void {
		this.setSubTitle(eventObj.currentSlide);
	}

	setSubTitle(index: number): void {
		this.selectedFieldName =
			this.isR1 && this.fields[index] == 'household_visits'
				? 'Website Attributions'
				: this.fields[index] == 'youtube_verified_imprs'
				? 'YouTube Views'
				: this.fields[index] == 'website_attributions'
				? 'Website Attributions'
				: this.isR8 && this.fields[index] == 'household_visits'
				? 'Household Visits'
				: this.fields[index];
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length > 0) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		const deviceData = this.mapDeviceReponseDataToModel(responseData);
		this.deviceChartObjArray = this.buildDeviceChartCollatorByFields(deviceData);
		this.setSubTitle(0);
	}

	mapDeviceReponseDataToModel(responseArray: any[]): DeviceInterface[] {
		const deviceData: DeviceInterface[] = [];
		for (const responseObj of responseArray) {
			const deviceModel: DeviceInterface = {} as DeviceInterface;
			deviceModel.device = responseObj.device;
			!UtilityService.isUndefined(responseObj.impressions)
				? (deviceModel.impressions = UtilityService.isUndefinedOrNull(responseObj.impressions)
						? 0
						: parseFloat(responseObj.impressions))
				: '';
			!UtilityService.isUndefined(responseObj.clicks)
				? (deviceModel.clicks = UtilityService.isUndefinedOrNull(responseObj.clicks)
						? 0
						: parseFloat(responseObj.clicks))
				: '';
			!UtilityService.isUndefined(responseObj.view_throughs)
				? (deviceModel.viewThroughs = UtilityService.isUndefinedOrNull(responseObj.view_throughs)
						? 0
						: parseFloat(responseObj.view_throughs))
				: '';
			!UtilityService.isUndefined(responseObj.viewthroughrate)
				? (deviceModel.viewThroughRate = UtilityService.isUndefinedOrNull(responseObj.viewthroughrate)
						? 0
						: parseFloat(responseObj.viewthroughrate))
				: '';
			!UtilityService.isUndefined(responseObj.clickthroughrate)
				? (deviceModel.clickThroughRate = UtilityService.isUndefinedOrNull(responseObj.clickthroughrate)
						? 0
						: parseFloat(responseObj.clickthroughrate))
				: '';
			!UtilityService.isUndefined(responseObj.cost)
				? (deviceModel.cost = UtilityService.isUndefinedOrNull(responseObj.cost) ? 0 : parseFloat(responseObj.cost))
				: '';

			!UtilityService.isUndefined(responseObj.household_visits)
				? (deviceModel.household_visits = UtilityService.isUndefinedOrNull(responseObj.household_visits)
						? 0
						: parseFloat(responseObj.household_visits))
				: '';
			!UtilityService.isUndefined(responseObj.website_attributions)
				? (deviceModel.website_attributions = UtilityService.isUndefinedOrNull(responseObj.website_attributions)
						? 0
						: parseFloat(responseObj.website_attributions))
				: '';
			!UtilityService.isUndefined(responseObj.youtube_verified_imprs)
				? (deviceModel.youtube_verified_imprs = UtilityService.isUndefinedOrNull(responseObj.youtube_verified_imprs)
						? 0
						: parseFloat(responseObj.youtube_verified_imprs))
				: '';
			!UtilityService.isUndefined(responseObj.youtube_verified_imprs_rate)
				? (deviceModel.youtubeVerifiedImprsRate = UtilityService.isUndefinedOrNull(
						responseObj.youtube_verified_imprs_rate
				  )
						? 0
						: parseFloat(responseObj.youtube_verified_imprs_rate))
				: '';
			deviceData.push(deviceModel);
		}
		return deviceData;
	}

	buildDeviceChartCollatorByFields(deviceData: any): any[] {
		const fieldChartArray: any[] = [];
		for (const field of this.fields) {
			const chartObjArray: any[] = [];
			const chartData: any = {};
			for (let i = 0; i < deviceData.length; i++) {
				const chartObj: any = {};
				chartObj.name = deviceData[i].device;
				chartObj.color = this.getColorFromColorConfig(i, 1);
				chartObj.y = deviceData[i][field];
				chartObjArray.push(chartObj);
			}
			chartData.chartObj = chartObjArray;
			chartData.seriesName =
				this.isR1 && field == 'household_visits'
					? 'Website Attributions'
					: field == 'website_attributions'
					? 'Website Attributions'
					: field == 'youtube_verified_imprs'
					? 'YouTube Views'
					: field;
			fieldChartArray.push(chartData);
		}
		return fieldChartArray;
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
}
